import { render, staticRenderFns } from "./ContactDetailView.vue?vue&type=template&id=e262df92&"
import script from "./ContactDetailView.vue?vue&type=script&lang=ts&"
export * from "./ContactDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports